<template>
    <div class="form-group">
        <label v-if="label" :for="name">{{label}}</label>
        <input class="form-control" :type="type" :id="name" :name="name" :placeholder="placeholder" v-model="model[name]"
            :disabled="disabled" />
        <small class="form-text text-danger" v-if="errors[name]" v-text="errors[name][0]" />
    </div>
</template>

<script>
    export default {
        props: {
            label: {
                type: String
            },

            type: {
                type: String,
                default: 'text'
            },

            name: {
                type: String,
                required: true
            },

            model: {
                type: [Object, Array],
                required: true
            },

            errors: {
                type: [Object, Array],
                required: true
            },

            disabled: {
                type: Boolean
            }
        },

        computed: {
            placeholder() {
                return `${this.Lang.get('messages.enter')} ${this.label}`;
            }
        }
    };

</script>

<style>
</style>
